import * as R from 'ramda'
import React, { Component } from 'react'
import PouchDB from 'pouchdb-browser'
// import pouchDBAuth from 'pouchdb-authentication'

// PouchDB.plugin(pouchDBAuth)

export default class PouchAuth extends Component {
    componentWillMount() {
		this.auth(this.props)
  	}
  	componentWillReceiveProps(nextProps) {
  		this.auth(nextProps)
  	}
  	auth(props) {
		if (props.password) {
			this.login(props)
		} else {
			this.checkSession(props)
		}
  	}
	checkSession(props) {
		console.log('PouchAuth.checkSession')
		fetch(`${props.db}/_session`, {
			credentials: 'include'
		})
		.then(x => x.json())
		.then(x => {
			if (x.ok && x.userCtx.name && x.userCtx.name === props.username) {
				console.log('PouchAuth.checkSession.onSuccess')
				props.onSuccess()
			} else {
				this.logout(props)
				console.warn('PouchAuth.checkSession.onFail')
				props.onFail('')
			}
		})
		.catch(err => {
			console.error('PouchAuth.checkSession', err)
			props.onError(err)
		})
	}
	login(props) {
		console.log('PouchAuth.login')
		fetch(`${props.db}/_session`, {
			method: 'POST'
		  , credentials: 'include'
		  , headers: { 'Content-Type': 'application/json' }
		  , body: JSON.stringify({
		  		name: props.username
		  	  , password: props.password
		  	})
		})
		.then(x => x.json())
		.then(x => {
			if (x.ok && x.userCtx.name && x.userCtx.name === props.username) {
				console.log('PouchAuth.login.onSuccess')
				props.onSuccess()
			} else {
				console.warn('PouchAuth.login.onFail')
				props.onFail('Invalid login or password')
			}
		})
		.catch(err => {
			console.error('PouchAuth.login', err)
			props.onError(err)
		})
	}
	logout(props) {
		console.log('PouchAuth.logout')
		fetch(`${props.db}/_session`, {
			method: 'DELETE'
		  , credentials: 'include'
		})
	}
	render() {
  		return null
  	}
}



// WEBPACK FOOTER //
// ./src/components/drivers/PouchAuth.js